import React from "react";
import { Form, Formik } from "formik";
import { Link } from "react-router-dom";
import * as Yup from "yup";

import { Input } from "src/components/input/input";
import { School } from "src/generated/types";
import { Routes } from "src/utils/routes";

/*
 * Types
 */

interface SchoolInfoFormProps {
    school?: School | null;
}

interface FormValues {
    address: string;
    schoolName: string;
}

/*
 * Main
 */

export const SchoolInfoForm = (props: SchoolInfoFormProps): React.ReactElement => {
    const { school } = props;

    const initialValues: FormValues = {
        schoolName: school?.name ?? "",
        address: school?.address ?? "",
    };

    return (
        <>
            <Formik
                initialValues={initialValues}
                onSubmit={(_, { setSubmitting }): void => {
                    setSubmitting(false);
                }}
                validationSchema={Yup.object().shape({
                    schoolName: Yup.string().required("Required"),
                    address: Yup.string().required("Required"),
                })}
            >
                {() => (
                    <Form>
                        <Input
                            autoComplete="organization"
                            id="schoolName"
                            label="School Name"
                            name="schoolName"
                            placeholder="Organization Name"
                            readOnly
                            type="text"
                        />
                        <Input
                            autoComplete="address-level2"
                            id="address"
                            label="Address"
                            name="address"
                            placeholder="Organization Address"
                            readOnly
                            type="text"
                        />
                    </Form>
                )}
            </Formik>
            <Link
                className="whats-this-text"
                to={{
                    hash: "#contact-us",
                    pathname: Routes.about,
                }}
            >
                I Need to Update This Information
            </Link>
        </>
    );
};
